// Number.isFinite is not declared as a type guard, so a call site that has just
// proven a value finite still needs a `!` and a comment excusing it. This is
// that proof in a form the checker follows, stated once.
export function isFiniteNumber(v: unknown): v is number {
  return typeof v === 'number' && Number.isFinite(v);
}
